export default function noop() { }
;
